import { Component, effect, input, model, viewChild } from '@angular/core';
import { IconComponent, ResolvableModal } from '@softline/ui-core';
import { OrderItemCardComponent } from '../../components/order-item-card/order-item-card.component';
import { OrderItemsFormComponent } from '../../components/order-items-form/order-items-form.component';
import { OrderItem } from '../../models/order-item';
import { ChangeDetectionStrategy } from '@angular/core';
import { ScannedProduct } from '../../repositories/item-scan.repository';

@Component({
  selector: 'soft-garage-order-items-modal',
  templateUrl: './order-items-modal.component.html',
  styleUrls: ['./order-items-modal.component.css'],
  imports: [OrderItemsFormComponent, IconComponent, OrderItemCardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderItemsModalComponent extends ResolvableModal<OrderItem[] | null> {
  readonly items = model<OrderItem[]>([]);

  /** Optional product to pre-fill the form with (e.g. from a barcode scan). */
  readonly product = input<ScannedProduct | null>(null);

  private readonly form = viewChild(OrderItemsFormComponent);

  constructor() {
    super();
    effect(() => {
      const product = this.product();
      const form = this.form();
      if (product && form) form.setProduct(product);
    });
  }
}
